module.exports = __webpack_public_path__ + "assets/img/murphy.5b8be136.png";